export default __webpack_public_path__ + "static/media/sfondolore.220e6d8d.png";